import type { Event, ListItem, WithContext } from 'schema-dts'
import type { MaybeRefOrGetter } from 'vue'
import { computed, ref, toValue, watch } from 'vue'

const useAlgoliaEventCarouselSchema = (
  eventSchemas: MaybeRefOrGetter<WithContext<Event>[]>
): any => {
  const schema = ref<WithContext<any> | undefined>(undefined)
  const script = computed(() => ({
    type: 'application/ld+json',
    innerHTML: schema.value,
  }))

  const createSchema = (items: WithContext<Event>[]): ListItem[] => {
    return items.map((event, id) => {
      const obj: ListItem = {
        '@type': 'ListItem',
        position: id + 1,
        item: event,
      }

      return obj as ListItem
    })
  }

  watch(
    () => toValue(eventSchemas),
    (items) => {
      schema.value = {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        itemListElement: createSchema(items ?? []),
      }
    },
    { immediate: true, deep: true }
  )

  return {
    schema,
    script,
  }
}

export default useAlgoliaEventCarouselSchema
